import { ReactNode, createContext, useContext, useMemo } from 'react'
import { PromotionList } from './promotions.schema'
// eslint-disable-next-line import/no-restricted-paths
import type { PriceTier } from '../../product/shared/product.schema'
import { PROMOTIONS } from './promotions.constants'
import { getDisplayPromotion } from './promotions.utils'

const Context = createContext<PromotionList>([])

interface PromotionsProviderProps {
  promotions: PromotionList
  children: ReactNode
}

export function PromotionsProvider({ promotions, children }: PromotionsProviderProps) {
  return <Context.Provider value={promotions}>{children}</Context.Provider>
}

interface UsePromotionArgs {
  price?: PriceTier
}
export function usePromotion({ price: oldTier }: UsePromotionArgs | undefined = {}) {
  const readstorePromotions = useContext(Context)

  /**
   * While we are developing the promotion sync, we will maintain the promotions from constant.ts
   * We only have promotions form readstore when the FF is enabled.
   */
  const displayPromotions = useMemo(
    () => [...readstorePromotions, ...PROMOTIONS].map((promotion) => getDisplayPromotion(promotion, oldTier)),
    [readstorePromotions, oldTier]
  )

  return {
    promotions: displayPromotions,
  }
}
